import { render, staticRenderFns } from "./basicChargeRate.vue?vue&type=template&id=636207ca&scoped=true"
import script from "./basicChargeRate.vue?vue&type=script&lang=js"
export * from "./basicChargeRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636207ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('636207ca')) {
      api.createRecord('636207ca', component.options)
    } else {
      api.reload('636207ca', component.options)
    }
    module.hot.accept("./basicChargeRate.vue?vue&type=template&id=636207ca&scoped=true", function () {
      api.rerender('636207ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/haipu_terminal/rate_config/components/basicChargeRate.vue"
export default component.exports